// "Sign in with Google" button, made to Google's sign-in branding guidelines
// (developers.google.com/identity/branding-guidelines, page of 2026-07-07). Use this component for every
// Google sign-in in the console. Do not change the logo file, the label or the sizes in styles.css.
import { useId } from "react";
import googleG from "../assets/google-g.svg?raw";

export const GOOGLE_SIGNIN_LABEL = "Sign in with Google";

// The IDs in the official file end with this suffix (mask, filters, clip path).
const LOGO_ID_SUFFIX = "_1298_12516";

/**
 * The official logo SVG with its IDs made unique for one button, so two buttons on a page do not share a mask
 * or a filter. Only the IDs change. The logo is inline because WebKit draws an SVG <img> with this gradient at
 * 1x and blurs it on high-density screens (src/assets/README.md).
 */
export function googleLogoSvg(instance: string): string {
  return googleG.replaceAll(LOGO_ID_SUFFIX, `${LOGO_ID_SUFFIX}_${instance.replace(/[^A-Za-z0-9_-]/g, "")}`);
}

export function GoogleSignInButton({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
  const logo = googleLogoSvg(useId());
  return (
    <button type="button" className="gsi-button" disabled={disabled} onClick={onClick}>
      <span className="gsi-button-state" aria-hidden="true" />
      {/* Static, trusted asset from this repo; no user input. */}
      <span className="gsi-button-logo" aria-hidden="true" dangerouslySetInnerHTML={{ __html: logo }} />
      <span className="gsi-button-label">{GOOGLE_SIGNIN_LABEL}</span>
    </button>
  );
}
